"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsCancellation = void 0;
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const store_1 = require("../../store");
require("./app-settings-cancellation.less");
const store_2 = require("client/modules/users/store"); //E-076
const material_ui_1 = require("material-ui"); //E-076
const material_ui_icons_1 = require("material-ui-icons"); //E-076
const core_1 = require("@material-ui/core");
const moment = require("moment"); // E-076
const List_1 = require("material-ui/List"); // E-076
const ArrowDropUp_1 = require("material-ui-icons/ArrowDropUp"); // E-076
const ArrowDropDown_1 = require("material-ui-icons/ArrowDropDown"); // E-076
const confirmation_modal_1 = require("client/components/confirmation-modal");
let AppSettingsCancellation = class AppSettingsCancellation extends React.Component {
    // TMPP > Setting & Tools > Cancellations Updates E-076
    constructor(props) {
        super(props);
        this.cancellations = null;
        this.originalState = null;
        this.changed = false;
        this.selectedRId = null; // pk
        this.handleSaveButtonConfirmation = false; // pk
        this.isAscDesc = false; //pkkk
        this.isUserAscDesc = false; //pkkk
        this.isModifiedByAscDesc = false; //pkkk
        this.isCreatedAtAscDesc = false; //pkkk
        this.isDateModifiedAscDesc = false; //pkkk
        this.isDatedAscDesc = false; //pkkk
        this.hasopenCaret_1 = true; //E-076
        this.hasopenCaret_2 = false; //E-076
        this.hasopenCaret_3 = false; //E-076
        this.hasopenCaret_4 = false; //E-076
        this.hasopenCaret_5 = false; //E-076
        this.hasopenCaret_6 = false; //E-076
        this.isActiveBtnClicked = false;
        this.isActiveBtnCancel = true; // new add E-076.21
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.newEntry = {
            reason: "",
            timeout: 0,
            userAdded: "",
            createdAt: new Date()
        };
        this.generateSettings = async () => {
            const loadedCancellations = await store_1.appSettingsStore.readCancellations();
            this.cancellations = loadedCancellations === null || loadedCancellations === void 0 ? void 0 : loadedCancellations.data.sort(this.sortCancellation("reason", "asc")); // E-076.1
            this.originalState = this.stringifyData(loadedCancellations.data);
        };
        this.stringifyData = (data) => JSON.stringify(data.map((v) => JSON.stringify(v)));
        this.compareChanges = () => {
            const curState = this.stringifyData(this.cancellations);
            this.changed = curState !== this.originalState;
        };
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.handleSubmit = async () => {
            let finalObj = this.cancellations;
            await store_1.appSettingsStore.updateCancellations(finalObj);
            await this.generateSettings();
            this.changed = false;
            this.handleSaveButtonConfirmation = false;
        };
        this.handleConfirmationModal = () => {
            this.handleSaveButtonConfirmation = true;
        };
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.handleAdd = async () => {
            const userAdded = `${store_2.usersStore.user.value.firstName} ${store_2.usersStore.user.value.lastName}`; // E-080.2
            const createdAt = new Date(); // E-080.2
            this.newEntry["userAdded"] = userAdded;
            this.newEntry["createdAt"] = createdAt;
            // this.newEntry={ reason: "", timeout: 0 ,userAdded:userAdded,createdAt:createdAt}
            const result = await store_1.appSettingsStore.createCancellations(this.newEntry);
            await this.generateSettings();
            if (result) {
                this.newEntry.reason = ""; //E-076.1
                this.newEntry.timeout = 0; // E-076.1
            }
        };
        this.handleDelete = async (id) => {
            await store_1.appSettingsStore.deleteCancellations(id);
            await this.generateSettings();
            // this.setState({ reasonId: id });
            this.isActiveBtnClicked = false;
            this.setState({ modelOpenCancel: false }); // E-076
        };
        // E-076
        this.handleModalOpenCancel = async () => {
            this.setState({ modelOpenCancel: false });
        };
        // E-076
        this.handleCancel = async () => {
            // this.categories = null;
            // await this.generateSettings();
            // await this.generateCategoryNames();
            this.setState({ isDisabled: true });
            this.setState({ isActive: true });
            // this.dummyCat = this.categories;
            this.setState({ modelOpen: false });
            this.setState({ modelOpenCancel: false }); // E-080.3
        };
        // E-076
        this.handleRemove = async () => {
            await this.generateSettings();
            // await this.generateCategoryNames();
            this.setState({ isDisabled: true });
            this.setState({ modelOpenCancel: false });
        };
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.handleClick = (e) => {
            this.setState({ anchorEl: e.currentTarget });
        };
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.handleEditDetails = () => {
            this.setState({ modelOpen: true });
            this.setState({ anchorEl: null });
        };
        this.action_header = {
            color: "#101010",
            fontSize: "14px",
            cursor: "pointer",
            display: "flex" // new css add
        };
        this.main_head = {
            display: "flex",
            justifyContent: "center"
        };
        // TMPP > Setting & Tools > Cancellations Updates E-076
        this.renderContainer = () => {
            var _a, _b;
            let modifiedBy = `${store_2.usersStore.user.value.firstName} ${store_2.usersStore.user.value.lastName}`; // E-076
            let dateModified = new Date(); //E-076
            const currentUser = store_2.usersStore.user.value.firstName;
            if (!this.cancellations)
                return;
            // 76.1
            const cancellations = (_a = this.cancellations) === null || _a === void 0 ? void 0 : _a.map((reason, i) => {
                if (!reason.deletedAt) {
                    return (React.createElement(core_1.TableRow, null,
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long  annnnnnn", label: "Reason", value: reason.reason, disabled: this.isActiveBtnCancel, onChange: (_, v) => {
                                    this.cancellations[i].reason = v;
                                    this.cancellations[i].modifiedBy = modifiedBy;
                                    this.cancellations[i].dateModified = dateModified;
                                    this.compareChanges();
                                } })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-short", disabled: this.isActiveBtnCancel, label: "Days", onChange: (_, v) => {
                                    const value = v === "" ? null : v;
                                    this.cancellations[i].timeout = value;
                                    this.cancellations[i].modifiedBy = modifiedBy;
                                    this.cancellations[i].dateModified = dateModified;
                                    this.compareChanges();
                                }, value: reason.timeout, type: "number" })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long", label: "User Added", 
                                // value={reason.userAdded? reason.userAdded:currentUser.firstName}
                                value: reason.userAdded ? reason.userAdded : "", disabled: true, onChange: (_, v) => {
                                    this.cancellations[i].userAdded = v;
                                    this.compareChanges();
                                } })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long", label: "Date Added", value: reason.createdAt
                                    ? moment(reason.createdAt).format("MM/DD/YYYY")
                                    : "", disabled: true, onChange: (_, v) => {
                                    this.cancellations[i].createdAt = v;
                                    this.compareChanges();
                                } })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long", label: "Modified By", value: reason.modifiedBy ? reason.modifiedBy : "", disabled: true, onChange: (_, v) => {
                                    this.cancellations[i].dateModified = v;
                                    this.compareChanges();
                                } })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                            React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long", label: "\tDate Modified", value: reason.dateModified
                                    ? moment(reason.dateModified).format("MM/DD/YYYY")
                                    : "", disabled: true, onChange: (_, v) => {
                                    this.cancellations[i].dateModified = v;
                                    this.compareChanges();
                                } })),
                        React.createElement(core_1.TableCell, { align: "right", className: "aannnn" }, this.isActiveBtnClicked && (React.createElement(material_ui_1.Button, { "aria-controls": "simple-menu", "aria-haspopup": "true", 
                            // onClick={async () => this.handleDelete(reason.id)}
                            onClick: () => {
                                this.selectedRId = reason.id;
                                this.setState({ modelOpenCancel: true });
                            }, style: { backgroundColor: "transparent" } },
                            React.createElement(material_ui_icons_1.Clear, null))))));
                }
            });
            const renderNewItem = (React.createElement("div", { className: "page-new-item" },
                React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-long-2", label: "Reason", value: this.newEntry.reason, onChange: (e, v) => (this.newEntry.reason = v) }),
                React.createElement(text_field_1.MaterialTextField, { className: "pageeee-row-short", label: "Days", value: this.newEntry.timeout, type: "number", numType: "integer", onChange: (e, v) => (this.newEntry.timeout = v) }),
                React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleAdd }, "Add"),
                React.createElement(button_1.MaterialButton, { disabled: !this.changed, primary: true, style: { marginLeft: "1em" }, onClick: this.handleConfirmationModal }, "Save"),
                !this.isActiveBtnCancel &&
                    React.createElement(button_1.MaterialButton // new changes here
                    , { disabled: !this.changed, primary: true, style: { marginLeft: "1em" }, onClick: () => {
                            this.isActiveBtnClicked = false;
                            this.generateSettings();
                            this.changed = false;
                        } }, "Cancel")));
            const buttons = (React.createElement("div", { style: { padding: "2em", textAlign: "right" } },
                this.handleSaveButtonConfirmation &&
                    React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Cancel", message: `Are you sure you would like to edit?`, onCancel: () => { this.handleSaveButtonConfirmation = !this.handleSaveButtonConfirmation; }, onConfirm: this.handleSubmit, title: "Review confirmation" }),
                ((_b = this.state) === null || _b === void 0 ? void 0 : _b.modelOpenCancel) && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Are you sure you would like to Remove?`, onCancel: () => {
                        this.setState({ modelOpenCancel: false });
                        this.isActiveBtnClicked = !this.isActiveBtnClicked;
                    }, onConfirm: () => this.handleDelete(this.selectedRId), title: "Delete confirmation" }))));
            const info = (React.createElement("p", { style: { margin: "0 auto 2em", width: "50%", textAlign: "justify" } },
                "The ",
                React.createElement("i", null, "Days"),
                " field indicates the number of days a medication will be delayed in claims before being unblocked again. An entry of 0 indicates there is no delay, and leaving the field blank indicates an indefinite delay. A check on ",
                React.createElement("i", null, "Confirm Removal"),
                " indicates that the user must explicitly agree to remove the medication from the omission list if it's being removed manually."));
            // E-076 new Chnages for cancaletions
            const headerInfo = (React.createElement(core_1.TableHead, null,
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: x => {
                                this.isAscDesc = !this.isAscDesc;
                                this.hasopenCaret_1 = true;
                                this.hasopenCaret_2 = false;
                                this.hasopenCaret_3 = false;
                                this.hasopenCaret_4 = false;
                                this.hasopenCaret_5 = false;
                                this.hasopenCaret_6 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("reason", this.isAscDesc ? "desc" : "asc"));
                                // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "Reason"),
                            this.hasopenCaret_1 &&
                                (this.isAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: () => {
                                this.isDatedAscDesc = !this.isDatedAscDesc;
                                this.hasopenCaret_2 = true;
                                this.hasopenCaret_1 = false;
                                this.hasopenCaret_3 = false;
                                this.hasopenCaret_4 = false;
                                this.hasopenCaret_5 = false;
                                this.hasopenCaret_6 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("timeout", this.isDatedAscDesc ? "desc" : "asc")); // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "Days"),
                            this.hasopenCaret_2 &&
                                (this.isDatedAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: () => {
                                this.isUserAscDesc = !this.isUserAscDesc;
                                this.hasopenCaret_3 = true;
                                this.hasopenCaret_2 = false;
                                this.hasopenCaret_1 = false;
                                this.hasopenCaret_4 = false;
                                this.hasopenCaret_5 = false;
                                this.hasopenCaret_6 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("userAdded", this.isUserAscDesc ? "desc" : "asc")); // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "User Added"),
                            this.hasopenCaret_3 &&
                                (this.isUserAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: () => {
                                this.isCreatedAtAscDesc = !this.isCreatedAtAscDesc;
                                this.hasopenCaret_4 = true;
                                this.hasopenCaret_2 = false;
                                this.hasopenCaret_1 = false;
                                this.hasopenCaret_3 = false;
                                this.hasopenCaret_5 = false;
                                this.hasopenCaret_6 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("createdAt", this.isCreatedAtAscDesc ? "desc" : "asc")); // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "Date Added"),
                            this.hasopenCaret_4 &&
                                (this.isCreatedAtAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: () => {
                                this.isModifiedByAscDesc = !this.isModifiedByAscDesc;
                                this.hasopenCaret_5 = true;
                                this.hasopenCaret_2 = false;
                                this.hasopenCaret_1 = false;
                                this.hasopenCaret_3 = false;
                                this.hasopenCaret_4 = false;
                                this.hasopenCaret_6 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("modifiedBy", this.isModifiedByAscDesc ? "desc" : "asc")); // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "Modified By"),
                            this.hasopenCaret_5 &&
                                (this.isModifiedByAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement("div", { className: "tableheadercontent", onClick: () => {
                                this.isDateModifiedAscDesc = !this.isDateModifiedAscDesc;
                                this.hasopenCaret_6 = true;
                                this.hasopenCaret_2 = false;
                                this.hasopenCaret_1 = false;
                                this.hasopenCaret_3 = false;
                                this.hasopenCaret_4 = false;
                                this.hasopenCaret_5 = false;
                                this.cancellations = this.cancellations.sort(this.sortCancellation("dateModified", this.isDateModifiedAscDesc ? "desc" : "asc")); // E-076.1
                            } },
                            React.createElement("strong", { style: this.action_header }, "Date Modified"),
                            this.hasopenCaret_6 &&
                                (this.isDateModifiedAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(ArrowDropDown_1.default, null)))))),
                    React.createElement(core_1.TableCell, { align: "right", className: "aannnn" },
                        React.createElement(material_ui_1.Button, { className: "cstm-edit-btn", "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: this.handleClick },
                            React.createElement(material_ui_icons_1.MoreVert, null)),
                        React.createElement(material_ui_1.Menu, { id: "simple-menu", anchorEl: this.state.anchorEl, 
                            // keepMounted={false}
                            open: this.state.anchorEl, onClose: () => this.setState({ anchorEl: null }) },
                            React.createElement(material_ui_1.MenuItem, { onClick: () => {
                                    this.isActiveBtnCancel = !this.isActiveBtnCancel; // new Add E-076.1
                                    this.isActiveBtnClicked = !this.isActiveBtnClicked;
                                    this.setState({ anchorEl: null });
                                } },
                                React.createElement(material_ui_icons_1.Edit, { style: { marginRight: 15 } }),
                                " Edit"))))));
            // E-076
            const container = (React.createElement("div", { className: "---page---", style: { margin: "1em", textAlign: "center" } },
                renderNewItem,
                info,
                React.createElement("div", { className: "parent_cancellations" },
                    React.createElement("div", { className: "setting-table2" },
                        React.createElement(core_1.Table, { stickyHeader: true, "aria-label": "sticky table" },
                            headerInfo,
                            React.createElement(core_1.TableBody, null, cancellations)))),
                buttons));
            return container;
        };
        this.state = {
            anchorEl: null,
            diloagOpen: false,
            modelOpen: false,
            modelOpenCancel: false,
            warning: "",
            codeItem: "",
            reasonId: null
        };
    }
    async componentDidMount() {
        await this.generateSettings();
    }
    async componentWillUnmount() {
        this.cancellations = null;
    }
    // E-076.1
    sortCancellation(key, order = "asc") {
        console.log(this.hasopenCaret_1, "111", this.hasopenCaret_2, "2222", this.hasopenCaret_3);
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }
            // const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
            // const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
            const varA = a[key] ? (typeof a[key] === "string" ? a[key].toUpperCase() : a[key]) : "";
            const varB = b[key] ? (typeof b[key] === "string" ? b[key].toUpperCase() : b[key]) : "";
            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            }
            else if (varA < varB) {
                comparison = -1;
            }
            return order === "desc" ? comparison * -1 : comparison;
        };
    }
    render() {
        const didLoad = !!this.cancellations;
        return (React.createElement("div", null, didLoad ? this.renderContainer() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "cancellations", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "originalState", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "changed", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "selectedRId", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "handleSaveButtonConfirmation", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isUserAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isModifiedByAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isCreatedAtAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isDateModifiedAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isDatedAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_1", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_2", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_3", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_4", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_5", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "hasopenCaret_6", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isActiveBtnClicked", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "isActiveBtnCancel", void 0);
__decorate([
    mobx_1.observable
], AppSettingsCancellation.prototype, "newEntry", void 0);
AppSettingsCancellation = __decorate([
    mobx_react_1.observer
], AppSettingsCancellation);
exports.AppSettingsCancellation = AppSettingsCancellation;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-cancellation/app-settings-cancellation.tsx
// module id = 3188
// module chunks = 0